<template>
    <div class="partners-logos-wrapper">
        <div class="container-xxl padding-container-matrix">
            <div
                v-for="(partners, index) in sectionBlock.section"
                :key="'partners-section-' + index"
                class="row row-partners"
                >
                    <div class="col-12 mb-5">
                        <h6 v-if="partners.titreDeSection">{{partners.titreDeSection}}</h6>
                    </div>

                    <div
                        v-for="(el, indexel) in partners.partners"
                        :key="'partners-section-' + indexel"
                        class="col-12 col-sm-6 col-md-4 col-lg-3"
                    >
                        <a
                            v-if="el.lienVersSiteWeb.link !== ''"
                            :href="el.lienVersSiteWeb.link"
                            target="_blank"
                            class="card-partner link">

                            <div class="partner-logo-wrapper">
                               <img v-if="el.partnerLogo.url !== ''" :src="el.partnerLogo.url" :alt="el.partnerLogo.title" class="partner-logo">
                            </div>
                            <div class="partner-name-wrapper">
                                <p class="text-weight-semibold mb-0">{{el.partnerName}}</p>
                            </div>



                        </a>
                        <div v-else class="card-partner">
                            <div class="partner-logo-wrapper">
                                <img
                                    v-if="el.partnerLogo.url !== ''"
                                    :src="el.partnerLogo.url"
                                    :alt="el.partnerLogo.title"
                                    class="partner-logo"
                                >
                            </div>
                            <div class="partner-name-wrapper">
                                <p class="text-weight-semibold mb-0">{{el.partnerName}}</p>
                            </div>
                        </div>


                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'partnersLogos',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
